import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import baseUrl from "../../baseUrl";
import { parseJwt } from "../../utils/parseJwt";
import BlogCard from "../BlogCard/BlogCard";
import EmptyData from "../EmptyData/EmptyData";
import Spinner from "../Spinner/Spinner";

const MyBlogs = () => {
  const token = JSON.parse(localStorage.getItem("WM:user-token"));
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userId = parseJwt(token).id;
    setLoading(true);
    axios
      .post(
        `${baseUrl}/blog/own-blogs`,
        { userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          setBlogs(response.data.blogs);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);
  return (
    <>
      {loading && <Spinner />}
      {blogs.length <= 0 ? (
        <EmptyData message={"Oopss! You have not any blog post."} />
      ) : (
        <section className="py-4 bg-gray-100">
          <div className="container mx-auto">
            <div>
              <h1 className="text-2xl font-black text-gray-900 px-6 md:px-12">
                Your All Blog Posts
              </h1>
            </div>
            <div className="flex flex-wrap px-6">
              {blogs.map((blog) => (
                <BlogCard key={blog._id} blog={blog} />
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default MyBlogs;
